import _defineProperty from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
function e(e) {
  function t(e, t) {
    Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), this.message = e, this.code = t;
  }
  return t.prototype = new Error(), t.prototype.name = e, t.prototype.constructor = t, t;
}
var t = e("LaunchDarklyUnexpectedResponseError"),
  n = e("LaunchDarklyInvalidEnvironmentIdError"),
  r = e("LaunchDarklyInvalidUserError"),
  o = e("LaunchDarklyInvalidEventKeyError"),
  i = e("LaunchDarklyInvalidArgumentError"),
  a = e("LaunchDarklyFlagFetchError");
for (var s = {
    LDUnexpectedResponseError: t,
    LDInvalidEnvironmentIdError: n,
    LDInvalidUserError: r,
    LDInvalidEventKeyError: o,
    LDInvalidArgumentError: i,
    LDInvalidDataError: e("LaunchDarklyInvalidDataError"),
    LDFlagFetchError: a,
    LDTimeoutError: e("LaunchDarklyTimeoutError"),
    isHttpErrorRecoverable: function isHttpErrorRecoverable(e) {
      return !(e >= 400 && e < 500) || 400 === e || 408 === e || 429 === e;
    }
  }, c = function c(e) {
    var t = m(e),
      n = t[0],
      r = t[1];
    return 3 * (n + r) / 4 - r;
  }, u = function u(e) {
    var t,
      n,
      r = m(e),
      o = r[0],
      i = r[1],
      a = new g(function (e, t, n) {
        return 3 * (t + n) / 4 - n;
      }(0, o, i)),
      s = 0,
      c = i > 0 ? o - 4 : o;
    for (n = 0; n < c; n += 4) t = f[e.charCodeAt(n)] << 18 | f[e.charCodeAt(n + 1)] << 12 | f[e.charCodeAt(n + 2)] << 6 | f[e.charCodeAt(n + 3)], a[s++] = t >> 16 & 255, a[s++] = t >> 8 & 255, a[s++] = 255 & t;
    2 === i && (t = f[e.charCodeAt(n)] << 2 | f[e.charCodeAt(n + 1)] >> 4, a[s++] = 255 & t);
    1 === i && (t = f[e.charCodeAt(n)] << 10 | f[e.charCodeAt(n + 1)] << 4 | f[e.charCodeAt(n + 2)] >> 2, a[s++] = t >> 8 & 255, a[s++] = 255 & t);
    return a;
  }, l = function l(e) {
    for (var t, n = e.length, r = n % 3, o = [], i = 16383, a = 0, s = n - r; a < s; a += i) o.push(y(e, a, a + i > s ? s : a + i));
    1 === r ? (t = e[n - 1], o.push(d[t >> 2] + d[t << 4 & 63] + "==")) : 2 === r && (t = (e[n - 2] << 8) + e[n - 1], o.push(d[t >> 10] + d[t >> 4 & 63] + d[t << 2 & 63] + "="));
    return o.join("");
  }, d = [], f = [], g = "undefined" != typeof Uint8Array ? Uint8Array : Array, v = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", p = 0; p < 64; ++p) d[p] = v[p], f[v.charCodeAt(p)] = p;
function m(e) {
  var t = e.length;
  if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
  var n = e.indexOf("=");
  return -1 === n && (n = t), [n, n === t ? 0 : 4 - n % 4];
}
function h(e) {
  return d[e >> 18 & 63] + d[e >> 12 & 63] + d[e >> 6 & 63] + d[63 & e];
}
function y(e, t, n) {
  for (var r, o = [], i = t; i < n; i += 3) r = (e[i] << 16 & 16711680) + (e[i + 1] << 8 & 65280) + (255 & e[i + 2]), o.push(h(r));
  return o.join("");
}
f["-".charCodeAt(0)] = 62, f["_".charCodeAt(0)] = 63;
var w = {
    byteLength: c,
    toByteArray: u,
    fromByteArray: l
  },
  b = Array.isArray,
  k = Object.keys,
  E = Object.prototype.hasOwnProperty,
  D = function e(t, n) {
    if (t === n) return !0;
    if (t && n && "object" == typeof t && "object" == typeof n) {
      var r,
        o,
        i,
        a = b(t),
        s = b(n);
      if (a && s) {
        if ((o = t.length) != n.length) return !1;
        for (r = o; 0 !== r--;) if (!e(t[r], n[r])) return !1;
        return !0;
      }
      if (a != s) return !1;
      var c = t instanceof Date,
        u = n instanceof Date;
      if (c != u) return !1;
      if (c && u) return t.getTime() == n.getTime();
      var l = t instanceof RegExp,
        d = n instanceof RegExp;
      if (l != d) return !1;
      if (l && d) return t.toString() == n.toString();
      var f = k(t);
      if ((o = f.length) !== k(n).length) return !1;
      for (r = o; 0 !== r--;) if (!E.call(n, f[r])) return !1;
      for (r = o; 0 !== r--;) if (!e(t[i = f[r]], n[i])) return !1;
      return !0;
    }
    return t != t && n != n;
  };
var x = ["key", "ip", "country", "email", "firstName", "lastName", "avatar", "name"];
function O(e) {
  var t = unescape(encodeURIComponent(e));
  return w.fromByteArray(function (e) {
    var t = [];
    for (var _n = 0; _n < e.length; _n++) t.push(e.charCodeAt(_n));
    return t;
  }(t));
}
function C(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
var P,
  S = {
    appendUrlPath: function appendUrlPath(e, t) {
      return (e.endsWith("/") ? e.substring(0, e.length - 1) : e) + (t.startsWith("/") ? "" : "/") + t;
    },
    base64URLEncode: function base64URLEncode(e) {
      return O(e).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    },
    btoa: O,
    clone: function clone(e) {
      return JSON.parse(JSON.stringify(e));
    },
    deepEquals: function deepEquals(e, t) {
      return D(e, t);
    },
    extend: function extend() {
      for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
        e[_key] = arguments[_key];
      }
      return e.reduce(function (e, t) {
        return _objectSpread(_objectSpread({}, e), t);
      }, {});
    },
    getLDUserAgentString: function getLDUserAgentString(e) {
      var t = e.version || "?";
      return e.userAgent + "/" + t;
    },
    objectHasOwnProperty: C,
    onNextTick: function onNextTick(e) {
      setTimeout(e, 0);
    },
    sanitizeContext: function sanitizeContext(e) {
      if (!e) return e;
      var t;
      return null !== e.kind && void 0 !== e.kind || x.forEach(function (n) {
        var r = e[n];
        void 0 !== r && "string" != typeof r && (t = t || _objectSpread({}, e), t[n] = String(r));
      }), t || e;
    },
    transformValuesToVersionedValues: function transformValuesToVersionedValues(e) {
      var t = {};
      for (var _n2 in e) C(e, _n2) && (t[_n2] = {
        value: e[_n2],
        version: 0
      });
      return t;
    },
    transformVersionedValuesToValues: function transformVersionedValuesToValues(e) {
      var t = {};
      for (var _n3 in e) C(e, _n3) && (t[_n3] = e[_n3].value);
      return t;
    },
    wrapPromiseCallback: function wrapPromiseCallback(e, t) {
      var n = e.then(function (e) {
        return t && setTimeout(function () {
          t(null, e);
        }, 0), e;
      }, function (e) {
        if (!t) return Promise.reject(e);
        setTimeout(function () {
          t(e, null);
        }, 0);
      });
      return t ? void 0 : n;
    },
    once: function once(e) {
      var t,
        n = !1;
      return function () {
        for (var _len2 = arguments.length, r = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          r[_key2] = arguments[_key2];
        }
        return n || (n = !0, t = e.apply(this, r)), t;
      };
    }
  },
  I = new Uint8Array(16);
function T() {
  if (!P && !(P = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto))) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return P(I);
}
var F = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function L(e) {
  return "string" == typeof e && F.test(e);
}
for (var U, A, j = [], R = 0; R < 256; ++R) j.push((R + 256).toString(16).substr(1));
function N(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
    n = (j[e[t + 0]] + j[e[t + 1]] + j[e[t + 2]] + j[e[t + 3]] + "-" + j[e[t + 4]] + j[e[t + 5]] + "-" + j[e[t + 6]] + j[e[t + 7]] + "-" + j[e[t + 8]] + j[e[t + 9]] + "-" + j[e[t + 10]] + j[e[t + 11]] + j[e[t + 12]] + j[e[t + 13]] + j[e[t + 14]] + j[e[t + 15]]).toLowerCase();
  if (!L(n)) throw TypeError("Stringified UUID is invalid");
  return n;
}
var $ = 0,
  V = 0;
function H(e) {
  if (!L(e)) throw TypeError("Invalid UUID");
  var t,
    n = new Uint8Array(16);
  return n[0] = (t = parseInt(e.slice(0, 8), 16)) >>> 24, n[1] = t >>> 16 & 255, n[2] = t >>> 8 & 255, n[3] = 255 & t, n[4] = (t = parseInt(e.slice(9, 13), 16)) >>> 8, n[5] = 255 & t, n[6] = (t = parseInt(e.slice(14, 18), 16)) >>> 8, n[7] = 255 & t, n[8] = (t = parseInt(e.slice(19, 23), 16)) >>> 8, n[9] = 255 & t, n[10] = (t = parseInt(e.slice(24, 36), 16)) / 1099511627776 & 255, n[11] = t / 4294967296 & 255, n[12] = t >>> 24 & 255, n[13] = t >>> 16 & 255, n[14] = t >>> 8 & 255, n[15] = 255 & t, n;
}
function M(e, t, n) {
  function r(e, r, o, i) {
    if ("string" == typeof e && (e = function (e) {
      e = unescape(encodeURIComponent(e));
      for (var t = [], n = 0; n < e.length; ++n) t.push(e.charCodeAt(n));
      return t;
    }(e)), "string" == typeof r && (r = H(r)), 16 !== r.length) throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var a = new Uint8Array(16 + e.length);
    if (a.set(r), a.set(e, r.length), (a = n(a))[6] = 15 & a[6] | t, a[8] = 63 & a[8] | 128, o) {
      i = i || 0;
      for (var s = 0; s < 16; ++s) o[i + s] = a[s];
      return o;
    }
    return N(a);
  }
  try {
    r.name = e;
  } catch (e) {}
  return r.DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", r.URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8", r;
}
function q(e) {
  return 14 + (e + 64 >>> 9 << 4) + 1;
}
function z(e, t) {
  var n = (65535 & e) + (65535 & t);
  return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
}
function K(e, t, n, r, o, i) {
  return z((a = z(z(t, e), z(r, i))) << (s = o) | a >>> 32 - s, n);
  var a, s;
}
function _(e, t, n, r, o, i, a) {
  return K(t & n | ~t & r, e, t, o, i, a);
}
function J(e, t, n, r, o, i, a) {
  return K(t & r | n & ~r, e, t, o, i, a);
}
function B(e, t, n, r, o, i, a) {
  return K(t ^ n ^ r, e, t, o, i, a);
}
function W(e, t, n, r, o, i, a) {
  return K(n ^ (t | ~r), e, t, o, i, a);
}
var G = M("v3", 48, function (e) {
    if ("string" == typeof e) {
      var t = unescape(encodeURIComponent(e));
      e = new Uint8Array(t.length);
      for (var n = 0; n < t.length; ++n) e[n] = t.charCodeAt(n);
    }
    return function (e) {
      for (var t = [], n = 32 * e.length, r = "0123456789abcdef", o = 0; o < n; o += 8) {
        var i = e[o >> 5] >>> o % 32 & 255,
          a = parseInt(r.charAt(i >>> 4 & 15) + r.charAt(15 & i), 16);
        t.push(a);
      }
      return t;
    }(function (e, t) {
      e[t >> 5] |= 128 << t % 32, e[q(t) - 1] = t;
      for (var n = 1732584193, r = -271733879, o = -1732584194, i = 271733878, a = 0; a < e.length; a += 16) {
        var s = n,
          c = r,
          u = o,
          l = i;
        n = _(n, r, o, i, e[a], 7, -680876936), i = _(i, n, r, o, e[a + 1], 12, -389564586), o = _(o, i, n, r, e[a + 2], 17, 606105819), r = _(r, o, i, n, e[a + 3], 22, -1044525330), n = _(n, r, o, i, e[a + 4], 7, -176418897), i = _(i, n, r, o, e[a + 5], 12, 1200080426), o = _(o, i, n, r, e[a + 6], 17, -1473231341), r = _(r, o, i, n, e[a + 7], 22, -45705983), n = _(n, r, o, i, e[a + 8], 7, 1770035416), i = _(i, n, r, o, e[a + 9], 12, -1958414417), o = _(o, i, n, r, e[a + 10], 17, -42063), r = _(r, o, i, n, e[a + 11], 22, -1990404162), n = _(n, r, o, i, e[a + 12], 7, 1804603682), i = _(i, n, r, o, e[a + 13], 12, -40341101), o = _(o, i, n, r, e[a + 14], 17, -1502002290), n = J(n, r = _(r, o, i, n, e[a + 15], 22, 1236535329), o, i, e[a + 1], 5, -165796510), i = J(i, n, r, o, e[a + 6], 9, -1069501632), o = J(o, i, n, r, e[a + 11], 14, 643717713), r = J(r, o, i, n, e[a], 20, -373897302), n = J(n, r, o, i, e[a + 5], 5, -701558691), i = J(i, n, r, o, e[a + 10], 9, 38016083), o = J(o, i, n, r, e[a + 15], 14, -660478335), r = J(r, o, i, n, e[a + 4], 20, -405537848), n = J(n, r, o, i, e[a + 9], 5, 568446438), i = J(i, n, r, o, e[a + 14], 9, -1019803690), o = J(o, i, n, r, e[a + 3], 14, -187363961), r = J(r, o, i, n, e[a + 8], 20, 1163531501), n = J(n, r, o, i, e[a + 13], 5, -1444681467), i = J(i, n, r, o, e[a + 2], 9, -51403784), o = J(o, i, n, r, e[a + 7], 14, 1735328473), n = B(n, r = J(r, o, i, n, e[a + 12], 20, -1926607734), o, i, e[a + 5], 4, -378558), i = B(i, n, r, o, e[a + 8], 11, -2022574463), o = B(o, i, n, r, e[a + 11], 16, 1839030562), r = B(r, o, i, n, e[a + 14], 23, -35309556), n = B(n, r, o, i, e[a + 1], 4, -1530992060), i = B(i, n, r, o, e[a + 4], 11, 1272893353), o = B(o, i, n, r, e[a + 7], 16, -155497632), r = B(r, o, i, n, e[a + 10], 23, -1094730640), n = B(n, r, o, i, e[a + 13], 4, 681279174), i = B(i, n, r, o, e[a], 11, -358537222), o = B(o, i, n, r, e[a + 3], 16, -722521979), r = B(r, o, i, n, e[a + 6], 23, 76029189), n = B(n, r, o, i, e[a + 9], 4, -640364487), i = B(i, n, r, o, e[a + 12], 11, -421815835), o = B(o, i, n, r, e[a + 15], 16, 530742520), n = W(n, r = B(r, o, i, n, e[a + 2], 23, -995338651), o, i, e[a], 6, -198630844), i = W(i, n, r, o, e[a + 7], 10, 1126891415), o = W(o, i, n, r, e[a + 14], 15, -1416354905), r = W(r, o, i, n, e[a + 5], 21, -57434055), n = W(n, r, o, i, e[a + 12], 6, 1700485571), i = W(i, n, r, o, e[a + 3], 10, -1894986606), o = W(o, i, n, r, e[a + 10], 15, -1051523), r = W(r, o, i, n, e[a + 1], 21, -2054922799), n = W(n, r, o, i, e[a + 8], 6, 1873313359), i = W(i, n, r, o, e[a + 15], 10, -30611744), o = W(o, i, n, r, e[a + 6], 15, -1560198380), r = W(r, o, i, n, e[a + 13], 21, 1309151649), n = W(n, r, o, i, e[a + 4], 6, -145523070), i = W(i, n, r, o, e[a + 11], 10, -1120210379), o = W(o, i, n, r, e[a + 2], 15, 718787259), r = W(r, o, i, n, e[a + 9], 21, -343485551), n = z(n, s), r = z(r, c), o = z(o, u), i = z(i, l);
      }
      return [n, r, o, i];
    }(function (e) {
      if (0 === e.length) return [];
      for (var t = 8 * e.length, n = new Uint32Array(q(t)), r = 0; r < t; r += 8) n[r >> 5] |= (255 & e[r / 8]) << r % 32;
      return n;
    }(e), 8 * e.length));
  }),
  X = G;
function Q(e, t, n, r) {
  switch (e) {
    case 0:
      return t & n ^ ~t & r;
    case 1:
    case 3:
      return t ^ n ^ r;
    case 2:
      return t & n ^ t & r ^ n & r;
  }
}
function Y(e, t) {
  return e << t | e >>> 32 - t;
}
var Z = M("v5", 80, function (e) {
    var t = [1518500249, 1859775393, 2400959708, 3395469782],
      n = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
    if ("string" == typeof e) {
      var r = unescape(encodeURIComponent(e));
      e = [];
      for (var o = 0; o < r.length; ++o) e.push(r.charCodeAt(o));
    } else Array.isArray(e) || (e = Array.prototype.slice.call(e));
    e.push(128);
    for (var i = e.length / 4 + 2, a = Math.ceil(i / 16), s = new Array(a), c = 0; c < a; ++c) {
      for (var u = new Uint32Array(16), l = 0; l < 16; ++l) u[l] = e[64 * c + 4 * l] << 24 | e[64 * c + 4 * l + 1] << 16 | e[64 * c + 4 * l + 2] << 8 | e[64 * c + 4 * l + 3];
      s[c] = u;
    }
    s[a - 1][14] = 8 * (e.length - 1) / Math.pow(2, 32), s[a - 1][14] = Math.floor(s[a - 1][14]), s[a - 1][15] = 8 * (e.length - 1) & 4294967295;
    for (var d = 0; d < a; ++d) {
      for (var f = new Uint32Array(80), g = 0; g < 16; ++g) f[g] = s[d][g];
      for (var v = 16; v < 80; ++v) f[v] = Y(f[v - 3] ^ f[v - 8] ^ f[v - 14] ^ f[v - 16], 1);
      for (var p = n[0], m = n[1], h = n[2], y = n[3], w = n[4], b = 0; b < 80; ++b) {
        var k = Math.floor(b / 20),
          E = Y(p, 5) + Q(k, m, h, y) + w + t[k] + f[b] >>> 0;
        w = y, y = h, h = Y(m, 30) >>> 0, m = p, p = E;
      }
      n[0] = n[0] + p >>> 0, n[1] = n[1] + m >>> 0, n[2] = n[2] + h >>> 0, n[3] = n[3] + y >>> 0, n[4] = n[4] + w >>> 0;
    }
    return [n[0] >> 24 & 255, n[0] >> 16 & 255, n[0] >> 8 & 255, 255 & n[0], n[1] >> 24 & 255, n[1] >> 16 & 255, n[1] >> 8 & 255, 255 & n[1], n[2] >> 24 & 255, n[2] >> 16 & 255, n[2] >> 8 & 255, 255 & n[2], n[3] >> 24 & 255, n[3] >> 16 & 255, n[3] >> 8 & 255, 255 & n[3], n[4] >> 24 & 255, n[4] >> 16 & 255, n[4] >> 8 & 255, 255 & n[4]];
  }),
  ee = Z;
var te = Object.freeze({
  __proto__: null,
  v1: function v1(e, t, n) {
    var r = t && n || 0,
      o = t || new Array(16),
      i = (e = e || {}).node || U,
      a = void 0 !== e.clockseq ? e.clockseq : A;
    if (null == i || null == a) {
      var s = e.random || (e.rng || T)();
      null == i && (i = U = [1 | s[0], s[1], s[2], s[3], s[4], s[5]]), null == a && (a = A = 16383 & (s[6] << 8 | s[7]));
    }
    var c = void 0 !== e.msecs ? e.msecs : Date.now(),
      u = void 0 !== e.nsecs ? e.nsecs : V + 1,
      l = c - $ + (u - V) / 1e4;
    if (l < 0 && void 0 === e.clockseq && (a = a + 1 & 16383), (l < 0 || c > $) && void 0 === e.nsecs && (u = 0), u >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    $ = c, V = u, A = a;
    var d = (1e4 * (268435455 & (c += 122192928e5)) + u) % 4294967296;
    o[r++] = d >>> 24 & 255, o[r++] = d >>> 16 & 255, o[r++] = d >>> 8 & 255, o[r++] = 255 & d;
    var f = c / 4294967296 * 1e4 & 268435455;
    o[r++] = f >>> 8 & 255, o[r++] = 255 & f, o[r++] = f >>> 24 & 15 | 16, o[r++] = f >>> 16 & 255, o[r++] = a >>> 8 | 128, o[r++] = 255 & a;
    for (var g = 0; g < 6; ++g) o[r + g] = i[g];
    return t || N(o);
  },
  v3: X,
  v4: function v4(e, t, n) {
    var r = (e = e || {}).random || (e.rng || T)();
    if (r[6] = 15 & r[6] | 64, r[8] = 63 & r[8] | 128, t) {
      n = n || 0;
      for (var o = 0; o < 16; ++o) t[n + o] = r[o];
      return t;
    }
    return N(r);
  },
  v5: ee,
  NIL: "00000000-0000-0000-0000-000000000000",
  version: function version(e) {
    if (!L(e)) throw TypeError("Invalid UUID");
    return parseInt(e.substr(14, 1), 16);
  },
  validate: L,
  stringify: N,
  parse: H
});
var ne = ["debug", "info", "warn", "error", "none"];
var re = {
  commonBasicLogger: function commonBasicLogger(e, t) {
    if (e && e.destination && "function" != typeof e.destination) throw new Error("destination for basicLogger was set to a non-function");
    function n(e) {
      return function (t) {
        console && console[e] && console[e].call(console, t);
      };
    }
    var r = e && e.destination ? [e.destination, e.destination, e.destination, e.destination] : [n("log"), n("info"), n("warn"), n("error")],
      o = !(!e || !e.destination),
      i = e && void 0 !== e.prefix && null !== e.prefix ? e.prefix : "[LaunchDarkly] ";
    var a = 1;
    if (e && e.level) for (var _t2 = 0; _t2 < ne.length; _t2++) ne[_t2] === e.level && (a = _t2);
    function s(e, n, a) {
      if (a.length < 1) return;
      var s;
      var c = o ? n + ": " + i : i;
      if (1 !== a.length && t) {
        var _e2 = _toConsumableArray(a);
        _e2[0] = c + _e2[0], s = t.apply(void 0, _toConsumableArray(_e2));
      } else s = c + a[0];
      try {
        r[e](s);
      } catch (e) {
        console && console.log && console.log("[LaunchDarkly] Configured logger's " + n + " method threw an exception: " + e);
      }
    }
    var c = {};
    var _loop = function _loop() {
      var t = ne[_e3];
      if ("none" !== t) if (_e3 < a) c[t] = function () {};else {
        var _n4 = _e3;
        c[t] = function () {
          s(_n4, t, arguments);
        };
      }
    };
    for (var _e3 = 0; _e3 < ne.length; _e3++) {
      _loop();
    }
    return c;
  },
  validateLogger: function validateLogger(e) {
    ne.forEach(function (t) {
      if ("none" !== t && (!e[t] || "function" != typeof e[t])) throw new Error("Provided logger instance must support logger." + t + "(...) method");
    });
  }
};
function oe(e) {
  return e && e.message ? e.message : "string" == typeof e || e instanceof String ? e : JSON.stringify(e);
}
var ie = " Please see https://docs.launchdarkly.com/sdk/client-side/javascript#initialize-the-client for instructions on SDK initialization.";
var ae = {
  bootstrapInvalid: function bootstrapInvalid() {
    return "LaunchDarkly bootstrap data is not available because the back end could not read the flags.";
  },
  bootstrapOldFormat: function bootstrapOldFormat() {
    return "LaunchDarkly client was initialized with bootstrap data that did not include flag metadata. Events may not be sent correctly." + ie;
  },
  clientInitialized: function clientInitialized() {
    return "LaunchDarkly client initialized";
  },
  clientNotReady: function clientNotReady() {
    return "LaunchDarkly client is not ready";
  },
  debugEnqueueingEvent: function debugEnqueueingEvent(e) {
    return 'enqueueing "' + e + '" event';
  },
  debugPostingDiagnosticEvent: function debugPostingDiagnosticEvent(e) {
    return "sending diagnostic event (" + e.kind + ")";
  },
  debugPostingEvents: function debugPostingEvents(e) {
    return "sending " + e + " events";
  },
  debugStreamDelete: function debugStreamDelete(e) {
    return 'received streaming deletion for flag "' + e + '"';
  },
  debugStreamDeleteIgnored: function debugStreamDeleteIgnored(e) {
    return 'received streaming deletion for flag "' + e + '" but ignored due to version check';
  },
  debugStreamPatch: function debugStreamPatch(e) {
    return 'received streaming update for flag "' + e + '"';
  },
  debugStreamPatchIgnored: function debugStreamPatchIgnored(e) {
    return 'received streaming update for flag "' + e + '" but ignored due to version check';
  },
  debugStreamPing: function debugStreamPing() {
    return "received ping message from stream";
  },
  debugPolling: function debugPolling(e) {
    return "polling for feature flags at " + e;
  },
  debugStreamPut: function debugStreamPut() {
    return "received streaming update for all flags";
  },
  deprecated: function deprecated(e, t) {
    return t ? '"' + e + '" is deprecated, please use "' + t + '"' : '"' + e + '" is deprecated';
  },
  environmentNotFound: function environmentNotFound() {
    return "Environment not found. Double check that you specified a valid environment/client-side ID." + ie;
  },
  environmentNotSpecified: function environmentNotSpecified() {
    return "No environment/client-side ID was specified." + ie;
  },
  errorFetchingFlags: function errorFetchingFlags(e) {
    return "Error fetching flag settings: " + oe(e);
  },
  eventCapacityExceeded: function eventCapacityExceeded() {
    return "Exceeded event queue capacity. Increase capacity to avoid dropping events.";
  },
  eventWithoutContext: function eventWithoutContext() {
    return "Be sure to call `identify` in the LaunchDarkly client: https://docs.launchdarkly.com/sdk/features/identify#javascript";
  },
  httpErrorMessage: function httpErrorMessage(e, t, n) {
    return "Received error " + e + (401 === e ? " (invalid SDK key)" : "") + " for " + t + " - " + (s.isHttpErrorRecoverable(e) ? n : "giving up permanently");
  },
  httpUnavailable: function httpUnavailable() {
    return "Cannot make HTTP requests in this environment." + ie;
  },
  identifyDisabled: function identifyDisabled() {
    return "identify() has no effect here; it must be called on the main client instance";
  },
  inspectorMethodError: function inspectorMethodError(e, t) {
    return "an inspector: \"".concat(t, "\" of type: \"").concat(e, "\" generated an exception");
  },
  invalidContentType: function invalidContentType(e) {
    return 'Expected application/json content type but got "' + e + '"';
  },
  invalidData: function invalidData() {
    return "Invalid data received from LaunchDarkly; connection may have been interrupted";
  },
  invalidInspector: function invalidInspector(e, t) {
    return "an inspector: \"".concat(t, "\" of an invalid type (").concat(e, ") was configured");
  },
  invalidKey: function invalidKey() {
    return "Event key must be a string";
  },
  invalidMetricValue: function invalidMetricValue(e) {
    return "The track function was called with a non-numeric \"metricValue\" (".concat(e, "), only numeric metric values are supported.");
  },
  invalidContext: function invalidContext() {
    return "Invalid context specified." + ie;
  },
  invalidTagValue: function invalidTagValue(e) {
    return "Config option \"".concat(e, "\" must only contain letters, numbers, ., _ or -.");
  },
  localStorageUnavailable: function localStorageUnavailable(e) {
    return "local storage is unavailable: " + oe(e);
  },
  networkError: function networkError(e) {
    return "network error" + (e ? " (" + e + ")" : "");
  },
  optionBelowMinimum: function optionBelowMinimum(e, t, n) {
    return 'Config option "' + e + '" was set to ' + t + ", changing to minimum value of " + n;
  },
  streamClosing: function streamClosing() {
    return "Closing stream connection";
  },
  streamConnecting: function streamConnecting(e) {
    return "Opening stream connection to " + e;
  },
  streamError: function streamError(e, t) {
    return "Error on stream connection: " + oe(e) + ", will continue retrying after " + t + " milliseconds.";
  },
  tagValueTooLong: function tagValueTooLong(e) {
    return "Value of \"".concat(e, "\" was longer than 64 characters and was discarded.");
  },
  unknownCustomEventKey: function unknownCustomEventKey(e) {
    return 'Custom event "' + e + '" does not exist';
  },
  unknownOption: function unknownOption(e) {
    return 'Ignoring unknown config option "' + e + '"';
  },
  contextNotSpecified: function contextNotSpecified() {
    return "No context specified." + ie;
  },
  unrecoverableStreamError: function unrecoverableStreamError(e) {
    return "Error on stream connection ".concat(oe(e), ", giving up permanently");
  },
  wrongOptionType: function wrongOptionType(e, t, n) {
    return 'Config option "' + e + '" should be of type ' + t + ", got " + n + ", using default value";
  },
  wrongOptionTypeBoolean: function wrongOptionTypeBoolean(e, t) {
    return 'Config option "' + e + '" should be a boolean, got ' + t + ", converting to boolean";
  }
};
var se = re.validateLogger,
  ce = {
    baseUrl: {
      "default": "https://app.launchdarkly.com"
    },
    streamUrl: {
      "default": "https://clientstream.launchdarkly.com"
    },
    eventsUrl: {
      "default": "https://events.launchdarkly.com"
    },
    sendEvents: {
      "default": !0
    },
    streaming: {
      type: "boolean"
    },
    sendLDHeaders: {
      "default": !0
    },
    requestHeaderTransform: {
      type: "function"
    },
    sendEventsOnlyForVariation: {
      "default": !1
    },
    useReport: {
      "default": !1
    },
    evaluationReasons: {
      "default": !1
    },
    eventCapacity: {
      "default": 100,
      minimum: 1
    },
    flushInterval: {
      "default": 2e3,
      minimum: 2e3
    },
    samplingInterval: {
      "default": 0,
      minimum: 0
    },
    streamReconnectDelay: {
      "default": 1e3,
      minimum: 0
    },
    allAttributesPrivate: {
      "default": !1
    },
    privateAttributes: {
      "default": []
    },
    bootstrap: {
      type: "string|object"
    },
    diagnosticRecordingInterval: {
      "default": 9e5,
      minimum: 2e3
    },
    diagnosticOptOut: {
      "default": !1
    },
    wrapperName: {
      type: "string"
    },
    wrapperVersion: {
      type: "string"
    },
    stateProvider: {
      type: "object"
    },
    application: {
      validator: function validator(e, t, n) {
        var r = {};
        t.id && (r.id = de("".concat(e, ".id"), t.id, n));
        t.version && (r.version = de("".concat(e, ".version"), t.version, n));
        return r;
      }
    },
    inspectors: {
      "default": []
    },
    hooks: {
      "default": []
    },
    plugins: {
      "default": []
    }
  },
  ue = /^(\w|\.|-)+$/;
function le(e) {
  return e && e.replace(/\/+$/, "");
}
function de(e, t, n) {
  if ("string" == typeof t && t.match(ue)) {
    if (!(t.length > 64)) return t;
    n.warn(ae.tagValueTooLong(e));
  } else n.warn(ae.invalidTagValue(e));
}
var fe = {
  baseOptionDefs: ce,
  validate: function validate(e, t, n, r) {
    var o = S.extend({
        logger: {
          "default": r
        }
      }, ce, n),
      i = {};
    function a(e) {
      S.onNextTick(function () {
        t && t.maybeReportError(new s.LDInvalidArgumentError(e));
      });
    }
    var c = S.extend({}, e || {});
    return function (e) {
      var t = e;
      Object.keys(i).forEach(function (e) {
        if (void 0 !== t[e]) {
          var _n5 = i[e];
          r && r.warn(ae.deprecated(e, _n5)), _n5 && (void 0 === t[_n5] && (t[_n5] = t[e]), delete t[e]);
        }
      });
    }(c), c = function (e) {
      var t = S.extend({}, e);
      return Object.keys(o).forEach(function (e) {
        void 0 !== t[e] && null !== t[e] || (t[e] = o[e] && o[e]["default"]);
      }), t;
    }(c), c = function (e) {
      var t = S.extend({}, e),
        n = function n(e) {
          if (null === e) return "any";
          if (void 0 === e) return;
          if (Array.isArray(e)) return "array";
          var t = typeof e;
          return "boolean" === t || "string" === t || "number" === t || "function" === t ? t : "object";
        };
      return Object.keys(e).forEach(function (i) {
        var s = e[i];
        if (null != s) {
          var _c = o[i];
          if (void 0 === _c) a(ae.unknownOption(i));else {
            var _o = _c.type || n(_c["default"]),
              _u = _c.validator;
            if (_u) {
              var _n6 = _u(i, e[i], r);
              void 0 !== _n6 ? t[i] = _n6 : delete t[i];
            } else if ("any" !== _o) {
              var _e4 = _o.split("|"),
                _r = n(s);
              _e4.indexOf(_r) < 0 ? "boolean" === _o ? (t[i] = !!s, a(ae.wrongOptionTypeBoolean(i, _r))) : (a(ae.wrongOptionType(i, _o, _r)), t[i] = _c["default"]) : "number" === _r && void 0 !== _c.minimum && s < _c.minimum && (a(ae.optionBelowMinimum(i, s, _c.minimum)), t[i] = _c.minimum);
            }
          }
        }
      }), t.baseUrl = le(t.baseUrl), t.streamUrl = le(t.streamUrl), t.eventsUrl = le(t.eventsUrl), t;
    }(c), se(c.logger), c;
  },
  getTags: function getTags(e) {
    var t = {};
    return e && (e.application && void 0 !== e.application.id && null !== e.application.id && (t["application-id"] = [e.application.id]), e.application && void 0 !== e.application.version && null !== e.application.id && (t["application-version"] = [e.application.version])), t;
  }
};
var ge = S.getLDUserAgentString;
var ve = {
  getLDHeaders: function getLDHeaders(e, t) {
    if (t && !t.sendLDHeaders) return {};
    var n = {};
    n[e.userAgentHeaderName || "User-Agent"] = ge(e), t && t.wrapperName && (n["X-LaunchDarkly-Wrapper"] = t.wrapperVersion ? t.wrapperName + "/" + t.wrapperVersion : t.wrapperName);
    var r = fe.getTags(t),
      o = Object.keys(r);
    return o.length && (n["x-launchdarkly-tags"] = o.sort().map(function (e) {
      return Array.isArray(r[e]) ? r[e].sort().map(function (t) {
        return "".concat(e, "/").concat(t);
      }) : ["".concat(e, "/").concat(r[e])];
    }).reduce(function (e, t) {
      return e.concat(t);
    }, []).join(" ")), n;
  },
  transformHeaders: function transformHeaders(e, t) {
    return t && t.requestHeaderTransform ? t.requestHeaderTransform(_objectSpread({}, e)) : e;
  }
};
var pe = te.v1,
  me = ve.getLDHeaders,
  he = ve.transformHeaders;
var ye = function ye(e, t, n) {
  var r = S.extend({
      "Content-Type": "application/json"
    }, me(e, n)),
    o = {};
  return o.sendEvents = function (t, o, i) {
    if (!e.httpRequest) return Promise.resolve();
    var a = JSON.stringify(t),
      c = i ? null : pe();
    return function t(u) {
      var l = i ? r : S.extend({}, r, {
        "X-LaunchDarkly-Event-Schema": "4",
        "X-LaunchDarkly-Payload-ID": c
      });
      return e.httpRequest("POST", o, he(l, n), a).promise.then(function (e) {
        if (e) return e.status >= 400 && s.isHttpErrorRecoverable(e.status) && u ? t(!1) : function (e) {
          var t = {
              status: e.status
            },
            n = e.header("date");
          if (n) {
            var _e5 = Date.parse(n);
            _e5 && (t.serverTime = _e5);
          }
          return t;
        }(e);
      })["catch"](function () {
        return u ? t(!1) : Promise.reject();
      });
    }(!0)["catch"](function () {});
  }, o;
};
var we = function e(t) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (null === t || "object" != typeof t) return JSON.stringify(t);
  if (n.includes(t)) throw new Error("Cycle detected");
  if (Array.isArray(t)) {
    return "[".concat(t.map(function (r) {
      return e(r, [].concat(_toConsumableArray(n), [t]));
    }).map(function (e) {
      return void 0 === e ? "null" : e;
    }).join(","), "]");
  }
  return "{".concat(Object.keys(t).sort().map(function (r) {
    var o = e(t[r], [].concat(_toConsumableArray(n), [t]));
    if (void 0 !== o) return "".concat(JSON.stringify(r), ":").concat(o);
  }).filter(function (e) {
    return void 0 !== e;
  }).join(","), "}");
};
var be = re.commonBasicLogger;
function ke(e) {
  return "string" == typeof e && "kind" !== e && e.match(/^(\w|\.|-)+$/);
}
function Ee(e) {
  return e.includes("%") || e.includes(":") ? e.replace(/%/g, "%25").replace(/:/g, "%3A") : e;
}
var De = {
  checkContext: function checkContext(e, t) {
    if (e) {
      if (t && (void 0 === e.kind || null === e.kind)) return void 0 !== e.key && null !== e.key;
      var _n7 = e.key,
        _r2 = void 0 === e.kind ? "user" : e.kind,
        _o2 = ke(_r2),
        _i = "multi" === _r2 || null != _n7 && "" !== _n7;
      if ("multi" === _r2) {
        var _t3 = Object.keys(e).filter(function (e) {
          return "kind" !== e;
        });
        return _i && _t3.every(function (e) {
          return ke(e);
        }) && _t3.every(function (t) {
          var n = e[t].key;
          return null != n && "" !== n;
        });
      }
      return _i && _o2;
    }
    return !1;
  },
  getContextKeys: function getContextKeys(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : be();
    if (!e) return;
    var n = {},
      r = e.kind,
      o = e.key;
    switch (r) {
      case void 0:
        n.user = "".concat(o);
        break;
      case "multi":
        Object.entries(e).filter(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 1),
            e = _ref2[0];
          return "kind" !== e;
        }).forEach(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
            e = _ref4[0],
            t = _ref4[1];
          t && t.key && (n[e] = t.key);
        });
        break;
      case null:
        t.warn("null is not a valid context kind: ".concat(e));
        break;
      case "":
        t.warn("'' is not a valid context kind: ".concat(e));
        break;
      default:
        n[r] = "".concat(o);
    }
    return n;
  },
  getContextKinds: function getContextKinds(e) {
    return e ? null === e.kind || void 0 === e.kind ? ["user"] : "multi" !== e.kind ? [e.kind] : Object.keys(e).filter(function (e) {
      return "kind" !== e;
    }) : [];
  },
  getCanonicalKey: function getCanonicalKey(e) {
    if (e) {
      if ((void 0 === e.kind || null === e.kind || "user" === e.kind) && e.key) return e.key;
      if ("multi" !== e.kind && e.key) return "".concat(e.kind, ":").concat(Ee(e.key));
      if ("multi" === e.kind) return Object.keys(e).sort().filter(function (e) {
        return "kind" !== e;
      }).map(function (t) {
        return "".concat(t, ":").concat(Ee(e[t].key));
      }).join(":");
    }
  }
};
var xe = De.getContextKinds;
var Oe = function Oe() {
  var e = {};
  var t = 0,
    n = 0,
    r = {},
    o = {};
  return e.summarizeEvent = function (e) {
    if ("feature" === e.kind) {
      var _i2 = e.key + ":" + (null !== e.variation && void 0 !== e.variation ? e.variation : "") + ":" + (null !== e.version && void 0 !== e.version ? e.version : ""),
        _a = r[_i2];
      var _s = o[e.key];
      _s || (_s = new Set(), o[e.key] = _s), function (e) {
        return e.context ? xe(e.context) : e.contextKeys ? Object.keys(e.contextKeys) : [];
      }(e).forEach(function (e) {
        return _s.add(e);
      }), _a ? _a.count = _a.count + 1 : r[_i2] = {
        count: 1,
        key: e.key,
        version: e.version,
        variation: e.variation,
        value: e.value,
        "default": e["default"]
      }, (0 === t || e.creationDate < t) && (t = e.creationDate), e.creationDate > n && (n = e.creationDate);
    }
  }, e.getSummary = function () {
    var e = {};
    var i = !0;
    for (var _i3 = 0, _Object$values = Object.values(r); _i3 < _Object$values.length; _i3++) {
      var _t4 = _Object$values[_i3];
      var _n8 = e[_t4.key];
      _n8 || (_n8 = {
        "default": _t4["default"],
        counters: [],
        contextKinds: _toConsumableArray(o[_t4.key])
      }, e[_t4.key] = _n8);
      var _r3 = {
        value: _t4.value,
        count: _t4.count
      };
      void 0 !== _t4.variation && null !== _t4.variation && (_r3.variation = _t4.variation), void 0 !== _t4.version && null !== _t4.version ? _r3.version = _t4.version : _r3.unknown = !0, _n8.counters.push(_r3), i = !1;
    }
    return i ? null : {
      startDate: t,
      endDate: n,
      features: e,
      kind: "summary"
    };
  }, e.clearSummary = function () {
    t = 0, n = 0, r = {}, o = {};
  }, e;
};
var Ce = function Ce(e) {
  var t = {},
    n = {};
  return {
    summarizeEvent: function summarizeEvent(e) {
      if ("feature" === e.kind) {
        var _r4 = we(e.context);
        if (!_r4) return;
        var _o3 = t[_r4];
        _o3 || (t[_r4] = Oe(), _o3 = t[_r4], n[_r4] = e.context), _o3.summarizeEvent(e);
      }
    },
    getSummaries: function getSummaries() {
      var r = t,
        o = n;
      return t = {}, n = {}, Object.entries(r).map(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
          t = _ref6[0],
          n = _ref6[1];
        var r = n.getSummary();
        return r.context = e.filter(o[t]), r;
      });
    }
  };
};
function Pe(e) {
  return e.replace(/~/g, "~0").replace(/\//g, "~1");
}
function Se(e) {
  return (e.startsWith("/") ? e.substring(1) : e).split("/").map(function (e) {
    return e.indexOf("~") >= 0 ? e.replace(/~1/g, "/").replace(/~0/g, "~") : e;
  });
}
function Ie(e) {
  return !e.startsWith("/");
}
function Te(e, t) {
  var n = Ie(e),
    r = Ie(t);
  if (n && r) return e === t;
  if (n) {
    var _n9 = Se(t);
    return 1 === _n9.length && e === _n9[0];
  }
  if (r) {
    var _n10 = Se(e);
    return 1 === _n10.length && t === _n10[0];
  }
  return e === t;
}
function Fe(e) {
  return "/".concat(Pe(e));
}
var Le = {
  cloneExcluding: function cloneExcluding(e, t) {
    var n = [],
      r = {},
      o = [];
    var _loop2 = function _loop2() {
      var e = n.pop();
      if (t.some(function (t) {
        return Te(t, e.ptr);
      })) o.push(e.ptr);else {
        var _t5 = e.source[e.key];
        if (null === _t5) e.parent[e.key] = _t5;else if (Array.isArray(_t5)) e.parent[e.key] = _toConsumableArray(_t5);else if ("object" == typeof _t5) {
          if (e.visited.includes(_t5)) return "continue";
          e.parent[e.key] = {}, n.push.apply(n, _toConsumableArray(Object.keys(_t5).map(function (n) {
            return {
              key: n,
              ptr: (r = e.ptr, o = Pe(n), "".concat(r, "/").concat(o)),
              source: _t5,
              parent: e.parent[e.key],
              visited: [].concat(_toConsumableArray(e.visited), [_t5])
            };
            var r, o;
          })));
        } else e.parent[e.key] = _t5;
      }
    };
    for (n.push.apply(n, _toConsumableArray(Object.keys(e).map(function (t) {
      return {
        key: t,
        ptr: Fe(t),
        source: e,
        parent: r,
        visited: [e]
      };
    }))); n.length;) {
      var _ret = _loop2();
      if (_ret === "continue") continue;
    }
    return {
      cloned: r,
      excluded: o.sort()
    };
  },
  compare: Te,
  literalToReference: Fe
};
var Ue = function Ue(e) {
  var t = {},
    n = e.allAttributesPrivate,
    r = e.privateAttributes || [],
    o = ["key", "kind", "_meta", "anonymous"],
    i = ["name", "ip", "firstName", "lastName", "email", "avatar", "country"],
    a = function a(e, t) {
      if ("object" != typeof e || null === e || Array.isArray(e)) return;
      var _Le$cloneExcluding = Le.cloneExcluding(e, function (e, t) {
          return (n || t && e.anonymous ? Object.keys(e) : [].concat(_toConsumableArray(r), _toConsumableArray(e._meta && e._meta.privateAttributes || []))).filter(function (e) {
            return !o.some(function (t) {
              return Le.compare(e, t);
            });
          });
        }(e, t)),
        i = _Le$cloneExcluding.cloned,
        a = _Le$cloneExcluding.excluded;
      return i.key = String(i.key), a.length && (i._meta || (i._meta = {}), i._meta.redactedAttributes = a), i._meta && (delete i._meta.privateAttributes, 0 === Object.keys(i._meta).length && delete i._meta), void 0 !== i.anonymous && (i.anonymous = !!i.anonymous), i;
    };
  return t.filter = function (e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    return void 0 === e.kind || null === e.kind ? a(function (e) {
      var t = _objectSpread(_objectSpread({}, e.custom || {}), {}, {
        kind: "user",
        key: e.key
      });
      void 0 !== e.anonymous && (t.anonymous = !!e.anonymous);
      for (var _i5 = 0, _i4 = i; _i5 < _i4.length; _i5++) {
        var _n11 = _i4[_i5];
        delete t[_n11], void 0 !== e[_n11] && null !== e[_n11] && (t[_n11] = String(e[_n11]));
      }
      return void 0 !== e.privateAttributeNames && null !== e.privateAttributeNames && (t._meta = t._meta || {}, t._meta.privateAttributes = e.privateAttributeNames.map(function (e) {
        return e.startsWith("/") ? Le.literalToReference(e) : e;
      })), t;
    }(e), t) : "multi" === e.kind ? function (e, t) {
      var n = {
          kind: e.kind
        },
        r = Object.keys(e);
      for (var _i6 = 0, _r5 = r; _i6 < _r5.length; _i6++) {
        var _o4 = _r5[_i6];
        if ("kind" !== _o4) {
          var _r6 = a(e[_o4], t);
          _r6 && (n[_o4] = _r6);
        }
      }
      return n;
    }(e, t) : a(e, t);
  }, t;
};
var Ae = De.getContextKeys;
var je = function je(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var i = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var a = {},
    c = i || ye(e, n, t),
    u = S.appendUrlPath(t.eventsUrl, "/events/bulk/" + n),
    l = Ue(t),
    d = Ce(l),
    f = t.samplingInterval,
    g = t.eventCapacity,
    v = t.flushInterval,
    p = t.logger;
  var m,
    h = [],
    y = 0,
    w = !1,
    b = !1;
  function k() {
    return 0 === f || 0 === Math.floor(Math.random() * f);
  }
  function E(e) {
    var t = S.extend({}, e);
    return "identify" === e.kind || "feature" === e.kind || "custom" === e.kind ? t.context = l.filter(e.context) : (t.contextKeys = Ae(e.context, p), delete t.context), "feature" === e.kind && (delete t.trackEvents, delete t.debugEventsUntilDate), t;
  }
  function D(e) {
    h.length < g ? (h.push(e), b = !1) : (b || (b = !0, p.warn(ae.eventCapacityExceeded())), r && r.incrementDroppedEvents());
  }
  return a.enqueue = function (e) {
    if (w) return;
    var t = !1,
      n = !1;
    var r;
    if (d.summarizeEvent(e), "feature" === e.kind ? k() && (t = !!e.trackEvents, n = !!(r = e).debugEventsUntilDate && r.debugEventsUntilDate > y && r.debugEventsUntilDate > new Date().getTime()) : t = k(), t && D(E(e)), n) {
      var _t6 = S.extend({}, e, {
        kind: "debug"
      });
      _t6.context = l.filter(_t6.context), delete _t6.trackEvents, delete _t6.debugEventsUntilDate, D(_t6);
    }
  }, a.flush = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var e;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!w) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", Promise.resolve());
        case 2:
          e = h;
          return _context.abrupt("return", (d.getSummaries().forEach(function (t) {
            Object.keys(t.features).length && e.push(t);
          }), r && r.setEventsInLastBatch(e.length), 0 === e.length ? Promise.resolve() : (h = [], p.debug(ae.debugPostingEvents(e.length)), c.sendEvents(e, u).then(function (e) {
            e && (e.serverTime && (y = e.serverTime), s.isHttpErrorRecoverable(e.status) || (w = !0), e.status >= 400 && S.onNextTick(function () {
              o.maybeReportError(new s.LDUnexpectedResponseError(ae.httpErrorMessage(e.status, "event posting", "some events were dropped")));
            }));
          }))));
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), a.start = function () {
    var e = function e() {
      a.flush(), m = setTimeout(e, v);
    };
    m = setTimeout(e, v);
  }, a.stop = function () {
    clearTimeout(m);
  }, a;
};
var Re = function Re(e) {
  var t = {},
    n = {};
  return t.on = function (e, t, r) {
    n[e] = n[e] || [], n[e] = n[e].concat({
      handler: t,
      context: r
    });
  }, t.off = function (e, t, r) {
    if (n[e]) for (var _o5 = 0; _o5 < n[e].length; _o5++) n[e][_o5].handler === t && n[e][_o5].context === r && (n[e] = n[e].slice(0, _o5).concat(n[e].slice(_o5 + 1)));
  }, t.emit = function (e) {
    if (!n[e]) return;
    var t = n[e].slice(0);
    for (var _e6 = 0; _e6 < t.length; _e6++) t[_e6].handler.apply(t[_e6].context, Array.prototype.slice.call(arguments, 1));
  }, t.getEvents = function () {
    return Object.keys(n);
  }, t.getEventListenerCount = function (e) {
    return n[e] ? n[e].length : 0;
  }, t.maybeReportError = function (t) {
    t && (n["error"] ? this.emit("error", t) : (e || console).error(t.message));
  }, t;
};
var Ne = "ready",
  $e = "initialized",
  Ve = "failed";
var He = function He(e) {
  var t = !1,
    n = !1,
    r = null,
    o = null;
  var i = new Promise(function (t) {
    var n = function n() {
      e.off(Ne, n), t();
    };
    e.on(Ne, n);
  })["catch"](function () {});
  return {
    getInitializationPromise: function getInitializationPromise() {
      return o || (t ? Promise.resolve() : n ? Promise.reject(r) : (o = new Promise(function (t, n) {
        var r = function r() {
            e.off($e, r), t();
          },
          o = function o(t) {
            e.off(Ve, o), n(t);
          };
        e.on($e, r), e.on(Ve, o);
      }), o));
    },
    getReadyPromise: function getReadyPromise() {
      return i;
    },
    signalSuccess: function signalSuccess() {
      t || n || (t = !0, e.emit($e), e.emit(Ne));
    },
    signalFailure: function signalFailure(o) {
      t || n || (n = !0, r = o, e.emit(Ve, o), e.emit(Ne)), e.maybeReportError(o);
    }
  };
};
var Me = function Me(e, t, n, r) {
  var o = {};
  function i() {
    var e = "";
    var o = r.getContext();
    return o && (e = n || S.btoa(JSON.stringify(o))), "ld:" + t + ":" + e;
  }
  return o.loadFlags = function () {
    return e.get(i()).then(function (e) {
      if (null == e) return null;
      try {
        var _t7 = JSON.parse(e);
        if (_t7) {
          var _e7 = _t7.$schema;
          void 0 === _e7 || _e7 < 1 ? _t7 = S.transformValuesToVersionedValues(_t7) : delete _t7.$schema;
        }
        return _t7;
      } catch (e) {
        return o.clearFlags().then(function () {
          return null;
        });
      }
    });
  }, o.saveFlags = function (t) {
    var n = S.extend({}, t, {
      $schema: 1
    });
    return e.set(i(), JSON.stringify(n));
  }, o.clearFlags = function () {
    return e.clear(i());
  }, o;
};
var qe = function qe(e, t) {
  var n = {};
  var r = !1;
  var o = function o(e) {
    r || (r = !0, t.warn(ae.localStorageUnavailable(e)));
  };
  return n.isEnabled = function () {
    return !!e;
  }, n.get = function (t) {
    return new Promise(function (n) {
      e ? e.get(t).then(n)["catch"](function (e) {
        o(e), n(void 0);
      }) : n(void 0);
    });
  }, n.set = function (t, n) {
    return new Promise(function (r) {
      e ? e.set(t, n).then(function () {
        return r(!0);
      })["catch"](function (e) {
        o(e), r(!1);
      }) : r(!1);
    });
  }, n.clear = function (t) {
    return new Promise(function (n) {
      e ? e.clear(t).then(function () {
        return n(!0);
      })["catch"](function (e) {
        o(e), n(!1);
      }) : n(!1);
    });
  }, n;
};
var ze = S.appendUrlPath,
  Ke = S.base64URLEncode,
  _e = S.objectHasOwnProperty,
  Je = ve.getLDHeaders,
  Be = ve.transformHeaders,
  We = s.isHttpErrorRecoverable;
var Ge = function Ge(e, t, n, r) {
  var o = t.streamUrl,
    i = t.logger,
    a = {},
    s = ze(o, "/eval/" + n),
    c = t.useReport,
    u = t.evaluationReasons,
    l = t.streamReconnectDelay,
    d = Je(e, t);
  var f,
    g = !1,
    v = null,
    p = null,
    m = null,
    h = null,
    y = null,
    w = 0;
  function b() {
    var e = (t = function () {
      var e = l * Math.pow(2, w);
      return e > 3e4 ? 3e4 : e;
    }(), t - Math.trunc(.5 * Math.random() * t));
    var t;
    return w += 1, e;
  }
  function k(e) {
    if (e.status && "number" == typeof e.status && !We(e.status)) return x(), i.error(ae.unrecoverableStreamError(e)), void (p && (clearTimeout(p), p = null));
    var t = b();
    g || (i.warn(ae.streamError(e, t)), g = !0), O(!1), x(), E(t);
  }
  function E(e) {
    p || (e ? p = setTimeout(D, e) : D());
  }
  function D() {
    var r;
    p = null;
    var a = "";
    var l = {
      headers: d,
      readTimeoutMillis: 3e5
    };
    if (e.eventSourceFactory) {
      null != h && (a = "h=" + h), c ? e.eventSourceAllowsReport ? (r = s, l.method = "REPORT", l.headers["Content-Type"] = "application/json", l.body = JSON.stringify(m)) : (r = ze(o, "/ping/" + n), a = "") : r = s + "/" + Ke(JSON.stringify(m)), l.headers = Be(l.headers, t), u && (a = a + (a ? "&" : "") + "withReasons=true"), r = r + (a ? "?" : "") + a, x(), i.info(ae.streamConnecting(r)), f = new Date().getTime(), v = e.eventSourceFactory(r, l);
      for (var _e8 in y) _e(y, _e8) && v.addEventListener(_e8, y[_e8]);
      v.onerror = k, v.onopen = function () {
        w = 0;
      };
    }
  }
  function x() {
    v && (i.info(ae.streamClosing()), v.close(), v = null);
  }
  function O(e) {
    f && r && r.recordStreamInit(f, !e, new Date().getTime() - f), f = null;
  }
  return a.connect = function (e, t, n) {
    m = e, h = t, y = {};
    var _loop3 = function _loop3(_e9) {
      y[_e9] = function (t) {
        g = !1, O(!0), n[_e9] && n[_e9](t);
      };
    };
    for (var _e9 in n || {}) {
      _loop3(_e9);
    }
    E();
  }, a.disconnect = function () {
    clearTimeout(p), p = null, x();
  }, a.isConnected = function () {
    return !!(v && e.eventSourceIsActive && e.eventSourceIsActive(v));
  }, a;
};
var Xe = function Xe(e) {
  var t, n, r, o;
  var i = {
    addPromise: function addPromise(i, a) {
      t = i, n && n(), n = a, i.then(function (n) {
        t === i && (r(n), e && e());
      }, function (n) {
        t === i && (o(n), e && e());
      });
    }
  };
  return i.resultPromise = new Promise(function (e, t) {
    r = e, o = t;
  }), i;
};
var Qe = ve.transformHeaders,
  Ye = ve.getLDHeaders,
  Ze = "application/json";
var et = function et(e, t, n) {
  var r = t.baseUrl,
    o = t.useReport,
    i = t.evaluationReasons,
    a = t.logger,
    c = {},
    u = {};
  function l(n, r) {
    if (!e.httpRequest) return new Promise(function (e, t) {
      t(new s.LDFlagFetchError(ae.httpUnavailable()));
    });
    var o = r ? "REPORT" : "GET",
      i = Ye(e, t);
    r && (i["Content-Type"] = Ze);
    var a = u[n];
    a || (a = Xe(function () {
      delete u[n];
    }), u[n] = a);
    var c = e.httpRequest(o, n, Qe(i, t), r),
      l = c.promise.then(function (e) {
        if (200 === e.status) {
          if (e.header("content-type") && e.header("content-type").substring(0, 16) === Ze) return JSON.parse(e.body);
          {
            var _t8 = ae.invalidContentType(e.header("content-type") || "");
            return Promise.reject(new s.LDFlagFetchError(_t8));
          }
        }
        return Promise.reject(function (e) {
          return 404 === e.status ? new s.LDInvalidEnvironmentIdError(ae.environmentNotFound()) : new s.LDFlagFetchError(ae.errorFetchingFlags(e.statusText || String(e.status)));
        }(e));
      }, function (e) {
        return Promise.reject(new s.LDFlagFetchError(ae.networkError(e)));
      });
    return a.addPromise(l, function () {
      c.cancel && c.cancel();
    }), a.resultPromise;
  }
  return c.fetchJSON = function (e) {
    return l(S.appendUrlPath(r, e), null);
  }, c.fetchFlagSettings = function (e, t) {
    var s,
      c,
      u,
      d = "";
    return o ? (c = [r, "/sdk/evalx/", n, "/context"].join(""), u = JSON.stringify(e)) : (s = S.base64URLEncode(JSON.stringify(e)), c = [r, "/sdk/evalx/", n, "/contexts/", s].join("")), t && (d = "h=" + t), i && (d = d + (d ? "&" : "") + "withReasons=true"), c = c + (d ? "?" : "") + d, a.debug(ae.debugPolling(c)), l(c, u);
  }, c;
};
var tt = function tt(e, t) {
  var n = {};
  var r;
  return n.setContext = function (e) {
    r = S.sanitizeContext(e), r && t && t(S.clone(r));
  }, n.getContext = function () {
    return r ? S.clone(r) : null;
  }, e && n.setContext(e), n;
};
var nt = te.v1,
  rt = De.getContextKinds;
var ot = function ot(e) {
  function t(e) {
    return null == e || "user" === e ? "ld:$anonUserId" : "ld:$contextKey:".concat(e);
  }
  function n(n, r) {
    return null !== r.key && void 0 !== r.key ? (r.key = r.key.toString(), Promise.resolve(r)) : r.anonymous ? function (n) {
      return e.get(t(n));
    }(n).then(function (o) {
      if (o) return r.key = o, r;
      {
        var _o6 = nt();
        return r.key = _o6, function (n, r) {
          return e.set(t(r), n);
        }(_o6, n).then(function () {
          return r;
        });
      }
    }) : Promise.reject(new s.LDInvalidUserError(ae.invalidContext()));
  }
  this.processContext = function (e) {
    if (!e) return Promise.reject(new s.LDInvalidUserError(ae.contextNotSpecified()));
    var t = S.clone(e);
    if ("multi" === e.kind) {
      var _e10 = rt(t);
      return Promise.all(_e10.map(function (e) {
        return n(e, t[e]);
      })).then(function () {
        return t;
      });
    }
    return n(e.kind, t);
  };
};
var it = te.v1,
  at = fe.baseOptionDefs,
  st = S.appendUrlPath;
var ct = {
  DiagnosticId: function DiagnosticId(e) {
    var t = {
      diagnosticId: it()
    };
    return e && (t.sdkKeySuffix = e.length > 6 ? e.substring(e.length - 6) : e), t;
  },
  DiagnosticsAccumulator: function DiagnosticsAccumulator(e) {
    var t, n, r, o;
    function i(e) {
      t = e, n = 0, r = 0, o = [];
    }
    return i(e), {
      getProps: function getProps() {
        return {
          dataSinceDate: t,
          droppedEvents: n,
          eventsInLastBatch: r,
          streamInits: o
        };
      },
      setProps: function setProps(e) {
        t = e.dataSinceDate, n = e.droppedEvents || 0, r = e.eventsInLastBatch || 0, o = e.streamInits || [];
      },
      incrementDroppedEvents: function incrementDroppedEvents() {
        n++;
      },
      setEventsInLastBatch: function setEventsInLastBatch(e) {
        r = e;
      },
      recordStreamInit: function recordStreamInit(e, t, n) {
        var r = {
          timestamp: e,
          failed: t,
          durationMillis: n
        };
        o.push(r);
      },
      reset: i
    };
  },
  DiagnosticsManager: function DiagnosticsManager(e, t, n, r, o, i, a) {
    var s = !!e.diagnosticUseCombinedEvent,
      c = "ld:" + o + ":$diagnostics",
      u = st(i.eventsUrl, "/events/diagnostic/" + o),
      l = i.diagnosticRecordingInterval,
      d = n;
    var f,
      g,
      v = !!i.streaming;
    var p = {};
    function m() {
      return {
        sdk: w(),
        configuration: b(),
        platform: e.diagnosticPlatformData
      };
    }
    function h(e) {
      i.logger && i.logger.debug(ae.debugPostingDiagnosticEvent(e)), r.sendEvents(e, u, !0).then(function () {})["catch"](function () {});
    }
    function y() {
      h(function () {
        var e = new Date().getTime();
        var t = _objectSpread({
          kind: s ? "diagnostic-combined" : "diagnostic",
          id: a,
          creationDate: e
        }, d.getProps());
        return s && (t = _objectSpread(_objectSpread({}, t), m())), d.reset(e), t;
      }()), g = setTimeout(y, l), f = new Date().getTime(), s && function () {
        if (t.isEnabled()) {
          var _e11 = _objectSpread({}, d.getProps());
          t.set(c, JSON.stringify(_e11));
        }
      }();
    }
    function w() {
      var t = _objectSpread({}, e.diagnosticSdkData);
      return i.wrapperName && (t.wrapperName = i.wrapperName), i.wrapperVersion && (t.wrapperVersion = i.wrapperVersion), t;
    }
    function b() {
      return {
        customBaseURI: i.baseUrl !== at.baseUrl["default"],
        customStreamURI: i.streamUrl !== at.streamUrl["default"],
        customEventsURI: i.eventsUrl !== at.eventsUrl["default"],
        eventsCapacity: i.eventCapacity,
        eventsFlushIntervalMillis: i.flushInterval,
        reconnectTimeMillis: i.streamReconnectDelay,
        streamingDisabled: !v,
        allAttributesPrivate: !!i.allAttributesPrivate,
        diagnosticRecordingIntervalMillis: i.diagnosticRecordingInterval,
        usingSecureMode: !!i.hash,
        bootstrapMode: !!i.bootstrap,
        fetchGoalsDisabled: !i.fetchGoals,
        sendEventsOnlyForVariation: !!i.sendEventsOnlyForVariation
      };
    }
    return p.start = function () {
      s ? function (e) {
        if (!t.isEnabled()) return e(!1);
        t.get(c).then(function (t) {
          if (t) try {
            var _e12 = JSON.parse(t);
            d.setProps(_e12), f = _e12.dataSinceDate;
          } catch (e) {}
          e(!0);
        })["catch"](function () {
          e(!1);
        });
      }(function (e) {
        if (e) {
          var _e13 = (f || 0) + l,
            _t9 = new Date().getTime();
          _t9 >= _e13 ? y() : g = setTimeout(y, _e13 - _t9);
        } else 0 === Math.floor(4 * Math.random()) ? y() : g = setTimeout(y, l);
      }) : (h(_objectSpread({
        kind: "diagnostic-init",
        id: a,
        creationDate: d.getProps().dataSinceDate
      }, m())), g = setTimeout(y, l));
    }, p.stop = function () {
      g && clearTimeout(g);
    }, p.setStreaming = function (e) {
      v = e;
    }, p;
  }
};
var ut = function ut(e, t) {
  var n = !1;
  var r = {
    type: e.type,
    name: e.name,
    synchronous: e.synchronous,
    method: function method() {
      try {
        e.method.apply(e, arguments);
      } catch (_unused) {
        n || (n = !0, t.warn(ae.inspectorMethodError(r.type, r.name)));
      }
    }
  };
  return r;
};
var lt = S.onNextTick,
  dt = {
    flagUsed: "flag-used",
    flagDetailsChanged: "flag-details-changed",
    flagDetailChanged: "flag-detail-changed",
    clientIdentityChanged: "client-identity-changed"
  };
Object.freeze(dt);
var ft = {
  InspectorTypes: dt,
  InspectorManager: function InspectorManager(e, t) {
    var _r7, _o7;
    var n = {},
      r = (_r7 = {}, _defineProperty(_r7, dt.flagUsed, []), _defineProperty(_r7, dt.flagDetailsChanged, []), _defineProperty(_r7, dt.flagDetailChanged, []), _defineProperty(_r7, dt.clientIdentityChanged, []), _r7),
      o = (_o7 = {}, _defineProperty(_o7, dt.flagUsed, []), _defineProperty(_o7, dt.flagDetailsChanged, []), _defineProperty(_o7, dt.flagDetailChanged, []), _defineProperty(_o7, dt.clientIdentityChanged, []), _o7),
      i = e && e.map(function (e) {
        return ut(e, t);
      });
    return i && i.forEach(function (e) {
      Object.prototype.hasOwnProperty.call(r, e.type) && !e.synchronous ? r[e.type].push(e) : Object.prototype.hasOwnProperty.call(o, e.type) && e.synchronous ? o[e.type].push(e) : t.warn(ae.invalidInspector(e.type, e.name));
    }), n.hasListeners = function (e) {
      return r[e] && r[e].length || o[e] && o[e].length;
    }, n.onFlagUsed = function (e, t, n) {
      var i = dt.flagUsed;
      o[i].length && o[i].forEach(function (r) {
        return r.method(e, t, n);
      }), r[i].length && lt(function () {
        r[i].forEach(function (r) {
          return r.method(e, t, n);
        });
      });
    }, n.onFlags = function (e) {
      var t = dt.flagDetailsChanged;
      o[t].length && o[t].forEach(function (t) {
        return t.method(e);
      }), r[t].length && lt(function () {
        r[t].forEach(function (t) {
          return t.method(e);
        });
      });
    }, n.onFlagChanged = function (e, t) {
      var n = dt.flagDetailChanged;
      o[n].length && o[n].forEach(function (n) {
        return n.method(e, t);
      }), r[n].length && lt(function () {
        r[n].forEach(function (n) {
          return n.method(e, t);
        });
      });
    }, n.onIdentityChanged = function (e) {
      var t = dt.clientIdentityChanged;
      o[t].length && o[t].forEach(function (t) {
        return t.method(e);
      }), r[t].length && lt(function () {
        r[t].forEach(function (t) {
          return t.method(e);
        });
      });
    }, n;
  }
};
var gt = s.LDTimeoutError;
var vt = function vt(e, t) {
  return new Promise(function (n, r) {
    setTimeout(function () {
      r(new gt("".concat(t, " timed out after ").concat(e, " seconds.")));
    }, 1e3 * e);
  });
};
var pt = "unknown hook";
function mt(e, t, n, r, o) {
  try {
    return r();
  } catch (r) {
    return e !== null && e !== void 0 && e.error("An error was encountered in \"".concat(t, "\" of the \"").concat(n, "\" hook: ").concat(r)), o;
  }
}
function ht(e, t) {
  try {
    return t.getMetadata().name || pt;
  } catch (_unused2) {
    return e.error("Exception thrown getting metadata for hook. Unable to get hook name."), pt;
  }
}
var yt = function yt(e, t) {
  var n = t ? _toConsumableArray(t) : [];
  return {
    withEvaluation: function withEvaluation(t, r, o, i) {
      if (0 === n.length) return i();
      var a = _toConsumableArray(n),
        s = {
          flagKey: t,
          context: r,
          defaultValue: o
        },
        c = function (e, t, n) {
          return t.map(function (t) {
            return mt(e, "beforeEvaluation", ht(e, t), function () {
              var _t$beforeEvaluation, _t$beforeEvaluation2;
              return (_t$beforeEvaluation = t === null || t === void 0 || (_t$beforeEvaluation2 = t.beforeEvaluation) === null || _t$beforeEvaluation2 === void 0 ? void 0 : _t$beforeEvaluation2.call(t, n, {})) !== null && _t$beforeEvaluation !== void 0 ? _t$beforeEvaluation : {};
            }, {});
          });
        }(e, a, s),
        u = i();
      return function (e, t, n, r, o) {
        var _loop4 = function _loop4() {
          var a = t[_i7],
            s = r[_i7];
          mt(e, "afterEvaluation", ht(e, a), function () {
            var _a$afterEvaluation, _a$afterEvaluation2;
            return (_a$afterEvaluation = a === null || a === void 0 || (_a$afterEvaluation2 = a.afterEvaluation) === null || _a$afterEvaluation2 === void 0 ? void 0 : _a$afterEvaluation2.call(a, n, s, o)) !== null && _a$afterEvaluation !== void 0 ? _a$afterEvaluation : {};
          }, {});
        };
        for (var _i7 = t.length - 1; _i7 >= 0; _i7 -= 1) {
          _loop4();
        }
      }(e, a, s, c, u), u;
    },
    identify: function identify(t, r) {
      var o = _toConsumableArray(n),
        i = {
          context: t,
          timeout: r
        },
        a = function (e, t, n) {
          return t.map(function (t) {
            return mt(e, "beforeIdentify", ht(e, t), function () {
              var _t$beforeIdentify, _t$beforeIdentify2;
              return (_t$beforeIdentify = t === null || t === void 0 || (_t$beforeIdentify2 = t.beforeIdentify) === null || _t$beforeIdentify2 === void 0 ? void 0 : _t$beforeIdentify2.call(t, n, {})) !== null && _t$beforeIdentify !== void 0 ? _t$beforeIdentify : {};
            }, {});
          });
        }(e, o, i);
      return function (t) {
        !function (e, t, n, r, o) {
          var _loop5 = function _loop5() {
            var a = t[_i8],
              s = r[_i8];
            mt(e, "afterIdentify", ht(e, a), function () {
              var _a$afterIdentify, _a$afterIdentify2;
              return (_a$afterIdentify = a === null || a === void 0 || (_a$afterIdentify2 = a.afterIdentify) === null || _a$afterIdentify2 === void 0 ? void 0 : _a$afterIdentify2.call(a, n, s, o)) !== null && _a$afterIdentify !== void 0 ? _a$afterIdentify : {};
            }, {});
          };
          for (var _i8 = t.length - 1; _i8 >= 0; _i8 -= 1) {
            _loop5();
          }
        }(e, o, i, a, t);
      };
    },
    addHook: function addHook(e) {
      n.push(e);
    },
    afterTrack: function afterTrack(t) {
      if (0 === n.length) return;
      var r = _toConsumableArray(n);
      !function (e, t, n) {
        var _loop6 = function _loop6() {
          var o = t[_r8];
          mt(e, "afterTrack", ht(e, o), function () {
            var _o$afterTrack;
            return o === null || o === void 0 || (_o$afterTrack = o.afterTrack) === null || _o$afterTrack === void 0 ? void 0 : _o$afterTrack.call(o, n);
          }, void 0);
        };
        for (var _r8 = t.length - 1; _r8 >= 0; _r8 -= 1) {
          _loop6();
        }
      }(e, r, t);
    }
  };
};
var wt = function wt() {
  var e,
    t = {};
  function n(n) {
    return e && S.objectHasOwnProperty(e, n) && e[n] ? e[n] : t && S.objectHasOwnProperty(t, n) && t[n] && !t[n].deleted ? t[n] : null;
  }
  return {
    clearAllOverrides: function clearAllOverrides() {
      if (!e) return {};
      var t = _objectSpread({}, e);
      return e = void 0, t;
    },
    get: n,
    getFlagOverrides: function getFlagOverrides() {
      return e || {};
    },
    getFlags: function getFlags() {
      return t;
    },
    getFlagsWithOverrides: function getFlagsWithOverrides() {
      var r = {};
      for (var _e14 in t) {
        var _t10 = n(_e14);
        _t10 && (r[_e14] = _t10);
      }
      if (e) for (var _t11 in e) {
        var _e15 = n(_t11);
        _e15 && (r[_t11] = _e15);
      }
      return r;
    },
    removeOverride: function removeOverride(t) {
      e && e[t] && (delete e[t], 0 === Object.keys(e).length && (e = void 0));
    },
    setFlags: function setFlags(e) {
      t = _objectSpread({}, e);
    },
    setOverride: function setOverride(t, n) {
      e || (e = {}), e[t] = {
        value: n
      };
    }
  };
};
var bt = "unknown plugin";
function kt(e, t) {
  try {
    return t.getMetadata().name || bt;
  } catch (t) {
    return e.error("Exception thrown getting metadata for plugin. Unable to get plugin name."), bt;
  }
}
var Et = {
  getPluginHooks: function getPluginHooks(e, t, n) {
    var r = [];
    return n.forEach(function (n) {
      try {
        var _n$getHooks;
        var _o8 = (_n$getHooks = n.getHooks) === null || _n$getHooks === void 0 ? void 0 : _n$getHooks.call(n, t);
        void 0 === _o8 ? e.error("Plugin ".concat(kt(e, n), " returned undefined from getHooks.")) : _o8 && _o8.length > 0 && r.push.apply(r, _toConsumableArray(_o8));
      } catch (t) {
        e.error("Exception thrown getting hooks for plugin ".concat(kt(e, n), ". Unable to get hooks."));
      }
    }), r;
  },
  registerPlugins: function registerPlugins(e, t, n, r) {
    r.forEach(function (r) {
      try {
        r.register(n, t);
      } catch (t) {
        e.error("Exception thrown registering plugin ".concat(kt(e, r), "."));
      }
    });
  },
  registerPluginsForDebugOverride: function registerPluginsForDebugOverride(e, t, n) {
    n.forEach(function (n) {
      try {
        var _n$registerDebug;
        (_n$registerDebug = n.registerDebug) === null || _n$registerDebug === void 0 ? void 0 : _n$registerDebug.call(n, t);
      } catch (t) {
        e.error("Exception thrown registering debug override with plugin ".concat(kt(e, n), "."));
      }
    });
  },
  createPluginEnvironment: function createPluginEnvironment(e, t, n) {
    var r = {};
    e.userAgent && (r.name = e.userAgent), e.version && (r.version = e.version), n.wrapperName && (r.wrapperName = n.wrapperName), n.wrapperVersion && (r.wrapperVersion = n.wrapperVersion);
    var o = {};
    n.application && (n.application.name && (o.name = n.application.name), n.application.version && (o.version = n.application.version));
    var i = {
      sdk: r,
      clientSideId: t
    };
    return Object.keys(o).length > 0 && (i.application = o), i;
  }
};
var Dt = re.commonBasicLogger,
  xt = De.checkContext,
  Ot = De.getContextKeys,
  Ct = ft.InspectorTypes,
  Pt = ft.InspectorManager,
  St = Et.getPluginHooks,
  It = Et.registerPlugins,
  Tt = Et.registerPluginsForDebugOverride,
  Ft = Et.createPluginEnvironment,
  Lt = "change",
  Ut = "internal-change";
var At = {
    initialize: function initialize(e, t, n, r, o) {
      var i = function () {
          if (n && n.logger) return n.logger;
          return o && o.logger && o.logger["default"] || Dt("warn");
        }(),
        a = Re(i),
        c = He(a),
        u = fe.validate(n, a, o, i),
        l = Pt(u.inspectors, i),
        d = u.sendEvents;
      var f = e,
        g = u.hash;
      var v = _toConsumableArray(u.plugins),
        p = Ft(r, e, u),
        m = St(i, p, v),
        h = yt(i, [].concat(_toConsumableArray(u.hooks), _toConsumableArray(m))),
        y = qe(r.localStorage, i),
        w = ye(r, f, u),
        b = u.sendEvents && !u.diagnosticOptOut,
        k = b ? ct.DiagnosticId(f) : null,
        E = b ? ct.DiagnosticsAccumulator(new Date().getTime()) : null,
        D = b ? ct.DiagnosticsManager(r, y, E, w, f, u, k) : null,
        x = Ge(r, u, f, E),
        O = u.eventProcessor || je(r, u, f, E, a, w),
        C = et(r, u, f),
        P = wt();
      var I,
        T,
        F,
        L = u.streaming,
        U = !1,
        A = !1,
        j = !0;
      var R = u.stateProvider,
        N = tt(null, function (e) {
          (function (e) {
            if (R) return;
            e && H({
              kind: "identify",
              context: e,
              creationDate: new Date().getTime()
            });
          })(e), l.hasListeners(Ct.clientIdentityChanged) && l.onIdentityChanged(N.getContext());
        }),
        $ = new ot(y),
        V = y.isEnabled() ? Me(y, f, g, N) : null;
      function H(e) {
        f && (R && R.enqueueEvent && R.enqueueEvent(e) || (e.context ? (j = !1, !d || A || r.isDoNotTrack() || (i.debug(ae.debugEnqueueingEvent(e.kind)), O.enqueue(e))) : j && (i.warn(ae.eventWithoutContext()), j = !1)));
      }
      function M(e, t) {
        l.hasListeners(Ct.flagDetailChanged) && l.onFlagChanged(e.key, J(t));
      }
      function q() {
        l.hasListeners(Ct.flagDetailsChanged) && l.onFlags(Object.entries(P.getFlagsWithOverrides()).map(function (_ref7) {
          var _ref8 = _slicedToArray(_ref7, 2),
            e = _ref8[0],
            t = _ref8[1];
          return {
            key: e,
            detail: J(t)
          };
        }).reduce(function (e, t) {
          return e[t.key] = t.detail, e;
        }, {}));
      }
      function z(e, t, n, r) {
        var o = N.getContext(),
          i = new Date(),
          a = {
            kind: "feature",
            key: e,
            context: o,
            value: t ? t.value : null,
            variation: t ? t.variationIndex : null,
            "default": n,
            creationDate: i.getTime()
          },
          s = P.getFlags()[e];
        s && (a.version = s.flagVersion ? s.flagVersion : s.version, a.trackEvents = s.trackEvents, a.debugEventsUntilDate = s.debugEventsUntilDate), (r || s && s.trackReason) && t && (a.reason = t.reason), H(a);
      }
      function K(e) {
        return xt(e, !1) ? Promise.resolve(e) : Promise.reject(new s.LDInvalidUserError(ae.invalidContext()));
      }
      function _(e, t, n, r, o, i) {
        var _s$prerequisites;
        var a;
        var s = P.get(e);
        return s ? (a = J(s), null !== s.value && void 0 !== s.value || (a.value = t)) : a = {
          value: t,
          variationIndex: null,
          reason: {
            kind: "ERROR",
            errorKind: "FLAG_NOT_FOUND"
          }
        }, n && (o || s !== null && s !== void 0 && (_s$prerequisites = s.prerequisites) !== null && _s$prerequisites !== void 0 && _s$prerequisites.forEach(function (e) {
          _(e, void 0, n, !1, !1, !1);
        }), z(e, a, t, r)), !o && i && function (e, t) {
          l.hasListeners(Ct.flagUsed) && l.onFlagUsed(e, t, N.getContext());
        }(e, a), a;
      }
      function J(e) {
        return {
          value: e.value,
          variationIndex: void 0 === e.variation ? null : e.variation,
          reason: e.reason || null
        };
      }
      function B() {
        if (T = !0, !N.getContext()) return;
        var e = function e(_e16) {
          try {
            return JSON.parse(_e16);
          } catch (e) {
            return void a.maybeReportError(new s.LDInvalidDataError(ae.invalidData()));
          }
        };
        x.connect(N.getContext(), g, {
          ping: function ping() {
            i.debug(ae.debugStreamPing());
            var e = N.getContext();
            C.fetchFlagSettings(e, g).then(function (t) {
              S.deepEquals(e, N.getContext()) && G(t || {});
            })["catch"](function (e) {
              a.maybeReportError(new s.LDFlagFetchError(ae.errorFetchingFlags(e)));
            });
          },
          put: function put(t) {
            var n = e(t.data);
            n && (i.debug(ae.debugStreamPut()), G(n));
          },
          patch: function patch(t) {
            var n = e(t.data);
            if (!n) return;
            var r = P.getFlags(),
              o = r[n.key];
            if (!o || !o.version || !n.version || o.version < n.version) {
              i.debug(ae.debugStreamPatch(n.key));
              var _e17 = {},
                _t12 = S.extend({}, n);
              delete _t12.key, r[n.key] = _t12, P.setFlags(r);
              var _a2 = J(_t12);
              _e17[n.key] = o ? {
                previous: o.value,
                current: _a2
              } : {
                current: _a2
              }, M(n, _t12), X(_e17);
            } else i.debug(ae.debugStreamPatchIgnored(n.key));
          },
          "delete": function _delete(t) {
            var n = e(t.data);
            if (!n) return;
            var r = P.getFlags();
            if (!r[n.key] || r[n.key].version < n.version) {
              i.debug(ae.debugStreamDelete(n.key));
              var _e18 = {};
              r[n.key] && !r[n.key].deleted && (_e18[n.key] = {
                previous: r[n.key].value
              }), r[n.key] = {
                version: n.version,
                deleted: !0
              }, P.setFlags(r), M(n, r[n.key]), X(_e18);
            } else i.debug(ae.debugStreamDeleteIgnored(n.key));
          }
        });
      }
      function W() {
        T && (x.disconnect(), T = !1);
      }
      function G(e) {
        var t = {};
        if (!e) return Promise.resolve();
        var n = P.getFlags();
        for (var _r9 in n) S.objectHasOwnProperty(n, _r9) && n[_r9] && (e[_r9] && !S.deepEquals(e[_r9].value, n[_r9].value) ? t[_r9] = {
          previous: n[_r9].value,
          current: J(e[_r9])
        } : e[_r9] && !e[_r9].deleted || (t[_r9] = {
          previous: n[_r9].value
        }));
        for (var _r10 in e) S.objectHasOwnProperty(e, _r10) && e[_r10] && (!n[_r10] || n[_r10].deleted) && (t[_r10] = {
          current: J(e[_r10])
        });
        return P.setFlags(_objectSpread({}, e)), q(), X(t)["catch"](function () {});
      }
      function X(e) {
        var t = Object.keys(e);
        if (t.length > 0) {
          var _n12 = {};
          t.forEach(function (t) {
            var r = e[t].current,
              o = r ? r.value : void 0,
              i = e[t].previous;
            a.emit(Lt + ":" + t, o, i), _n12[t] = r ? {
              current: o,
              previous: i
            } : {
              previous: i
            };
          }), a.emit(Lt, _n12), a.emit(Ut, P.getFlagsWithOverrides()), u.sendEventsOnlyForVariation || R || t.forEach(function (t) {
            z(t, e[t].current);
          });
        }
        return I && V ? V.saveFlags(P.getFlags()) : Promise.resolve();
      }
      function Q() {
        var e = L || F && void 0 === L;
        e && !T ? B() : !e && T && W(), D && D.setStreaming(e);
      }
      function Y(e) {
        return e === Lt || e.substr(0, 7) === Lt + ":";
      }
      if ("string" == typeof u.bootstrap && "LOCALSTORAGE" === u.bootstrap.toUpperCase() && (V ? I = !0 : i.warn(ae.localStorageUnavailable())), "object" == typeof u.bootstrap && P.setFlags(function (e) {
        var t = Object.keys(e),
          n = "$flagsState",
          r = "$valid",
          o = e[n];
        !o && t.length && i.warn(ae.bootstrapOldFormat()), !1 === e[r] && i.warn(ae.bootstrapInvalid());
        var a = {};
        return t.forEach(function (t) {
          if (t !== n && t !== r) {
            var _n13 = {
              value: e[t]
            };
            o && o[t] ? _n13 = S.extend(_n13, o[t]) : _n13.version = 0, a[t] = _n13;
          }
        }), a;
      }(u.bootstrap)), R) {
        var _e19 = R.getInitialState();
        _e19 ? Z(_e19) : R.on("init", Z), R.on("update", function (e) {
          e.context && N.setContext(e.context);
          e.flags && G(e.flags);
        });
      } else (function () {
        if (!e) return Promise.reject(new s.LDInvalidEnvironmentIdError(ae.environmentNotSpecified()));
        var n;
        return $.processContext(t).then(K).then(function (e) {
          return n = S.once(h.identify(e, void 0)), e;
        }).then(function (e) {
          var _n14;
          return (_n14 = n) !== null && _n14 !== void 0 && _n14({
            status: "completed"
          }), N.setContext(e), "object" == typeof u.bootstrap ? ee() : I ? V.loadFlags().then(function (e) {
            return null == e ? (P.setFlags({}), C.fetchFlagSettings(N.getContext(), g).then(function (e) {
              return G(e || {});
            }).then(ee)["catch"](function (e) {
              te(new s.LDFlagFetchError(ae.errorFetchingFlags(e)));
            })) : (P.setFlags(e), S.onNextTick(ee), C.fetchFlagSettings(N.getContext(), g).then(function (e) {
              return G(e);
            })["catch"](function (e) {
              return a.maybeReportError(e);
            }));
          }) : C.fetchFlagSettings(N.getContext(), g).then(function (e) {
            P.setFlags(e || {}), q(), ee();
          })["catch"](function (e) {
            P.setFlags({}), te(e);
          });
        })["catch"](function (e) {
          var _n15;
          throw (_n15 = n) !== null && _n15 !== void 0 && _n15({
            status: "error"
          }), e;
        });
      })()["catch"](te);
      function Z(e) {
        f = e.environment, N.setContext(e.context), P.setFlags(_objectSpread({}, e.flags)), S.onNextTick(ee);
      }
      function ee() {
        i.info(ae.clientInitialized()), U = !0, Q(), c.signalSuccess();
      }
      function te(e) {
        c.signalFailure(e);
      }
      var ne = {
        waitForInitialization: function waitForInitialization() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : void 0;
          if (null != e) {
            if ("number" == typeof e) return function (e) {
              e > 5 && i.warn("The waitForInitialization function was called with a timeout greater than 5 seconds. We recommend a timeout of 5 seconds or less.");
              var t = c.getInitializationPromise(),
                n = vt(e, "waitForInitialization");
              return Promise.race([n, t])["catch"](function (e) {
                throw e instanceof s.LDTimeoutError && i.error("waitForInitialization error: ".concat(e)), e;
              });
            }(e);
            i.warn("The waitForInitialization method was provided with a non-numeric timeout.");
          }
          return i.warn("The waitForInitialization function was called without a timeout specified. In a future version a default timeout will be applied."), c.getInitializationPromise();
        },
        waitUntilReady: function waitUntilReady() {
          return c.getReadyPromise();
        },
        identify: function identify(e, t, n) {
          if (A) return S.wrapPromiseCallback(Promise.resolve({}), n);
          if (R) return i.warn(ae.identifyDisabled()), S.wrapPromiseCallback(Promise.resolve(S.transformVersionedValuesToValues(P.getFlagsWithOverrides())), n);
          var r;
          var o = I && V ? V.clearFlags() : Promise.resolve();
          return S.wrapPromiseCallback(o.then(function () {
            return $.processContext(e);
          }).then(K).then(function (e) {
            return r = S.once(h.identify(e, void 0)), e;
          }).then(function (e) {
            return C.fetchFlagSettings(e, t).then(function (n) {
              var r = S.transformVersionedValuesToValues(n);
              return N.setContext(e), g = t, n ? G(n).then(function () {
                return r;
              }) : r;
            });
          }).then(function (e) {
            var _r11;
            return (_r11 = r) !== null && _r11 !== void 0 && _r11({
              status: "completed"
            }), T && B(), e;
          })["catch"](function (e) {
            var _r12;
            return (_r12 = r) !== null && _r12 !== void 0 && _r12({
              status: "error"
            }), a.maybeReportError(e), Promise.reject(e);
          }), n);
        },
        getContext: function getContext() {
          return N.getContext();
        },
        variation: function variation(e, t) {
          var _h$withEvaluation = h.withEvaluation(e, N.getContext(), t, function () {
              return _(e, t, !0, !1, !1, !0);
            }),
            n = _h$withEvaluation.value;
          return n;
        },
        variationDetail: function variationDetail(e, t) {
          return h.withEvaluation(e, N.getContext(), t, function () {
            return _(e, t, !0, !0, !1, !0);
          });
        },
        track: function track(e, t, n) {
          if ("string" != typeof e) return void a.maybeReportError(new s.LDInvalidEventKeyError(ae.unknownCustomEventKey(e)));
          void 0 !== n && "number" != typeof n && i.warn(ae.invalidMetricValue(typeof n)), r.customEventFilter && !r.customEventFilter(e) && i.warn(ae.unknownCustomEventKey(e));
          var o = N.getContext(),
            c = {
              kind: "custom",
              key: e,
              context: o,
              url: r.getCurrentUrl(),
              creationDate: new Date().getTime()
            };
          o && o.anonymous && (c.contextKind = o.anonymous ? "anonymousUser" : "user"), null != t && (c.data = t), null != n && (c.metricValue = n), H(c), h.afterTrack({
            context: o,
            key: e,
            data: t,
            metricValue: n
          });
        },
        on: function on(e, t, n) {
          Y(e) ? (F = !0, U && Q(), a.on(e, t, n)) : a.on.apply(a, arguments);
        },
        off: function off(e) {
          if (a.off.apply(a, arguments), Y(e)) {
            var _e20 = !1;
            a.getEvents().forEach(function (t) {
              Y(t) && a.getEventListenerCount(t) > 0 && (_e20 = !0);
            }), _e20 || (F = !1, T && void 0 === L && W());
          }
        },
        setStreaming: function setStreaming(e) {
          var t = null === e ? void 0 : e;
          t !== L && (L = t, Q());
        },
        flush: function flush(e) {
          return S.wrapPromiseCallback(d ? O.flush() : Promise.resolve(), e);
        },
        allFlags: function allFlags() {
          var e = {},
            t = P.getFlagsWithOverrides();
          if (!t) return e;
          for (var _n16 in t) e[_n16] = _(_n16, null, !u.sendEventsOnlyForVariation, !1, !0, !1).value;
          return e;
        },
        close: function close(e) {
          if (A) return S.wrapPromiseCallback(Promise.resolve(), e);
          var t = function t() {
              A = !0, P.setFlags({});
            },
            n = Promise.resolve().then(function () {
              if (W(), D && D.stop(), d) return O.stop(), O.flush();
            }).then(t)["catch"](t);
          return S.wrapPromiseCallback(n, e);
        },
        addHook: function addHook(e) {
          h.addHook(e);
        }
      };
      It(i, p, ne, v);
      var re = {
        setOverride: function setOverride(e, t) {
          var n = {},
            r = P.get(e),
            o = r ? r.value : null;
          if (o === t) return void i.debug("setOverride: No change needed for ".concat(e, ", value already ").concat(t));
          P.setOverride(e, t);
          var a = P.get(e),
            s = J(a);
          n[e] = {
            previous: o,
            current: s
          }, M({
            key: e
          }, a), X(n);
        },
        removeOverride: function removeOverride(e) {
          var t = P.getFlagOverrides();
          if (!t[e]) return;
          var n = {},
            r = t[e],
            o = P.getFlags()[e];
          n[e] = {
            previous: r.value,
            current: o ? J(o) : void 0
          }, P.removeOverride(e), M({
            key: e
          }, o), X(n);
        },
        clearAllOverrides: function clearAllOverrides() {
          var e = P.getFlagOverrides();
          if (0 === Object.keys(e).length) return;
          var t = {},
            n = P.getFlags();
          Object.keys(e).forEach(function (r) {
            var o = e[r],
              i = n[r];
            t[r] = {
              previous: o.value,
              current: i ? J(i) : void 0
            };
          }), P.clearAllOverrides(), Object.keys(t).length > 0 && X(t);
        },
        getAllOverrides: function getAllOverrides() {
          var e = P.getFlagOverrides();
          if (!e) return {};
          var t = {};
          return Object.keys(e).forEach(function (n) {
            var r = e[n];
            r && (t[n] = r.value);
          }), t;
        }
      };
      return Tt(i, re, v), {
        client: ne,
        options: u,
        emitter: a,
        ident: N,
        logger: i,
        requestor: C,
        start: function start() {
          d && (D && D.start(), O.start());
        },
        enqueueEvent: H,
        getFlagsInternal: function getFlagsInternal() {
          return P.getFlagsWithOverrides();
        },
        getEnvironmentId: function getEnvironmentId() {
          return f;
        },
        internalChangeEventName: Ut
      };
    },
    commonBasicLogger: Dt,
    errors: s,
    messages: ae,
    utils: S,
    getContextKeys: Ot
  },
  jt = At.initialize,
  Rt = At.errors,
  Nt = At.messages;
function $t(e, t, n) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" != typeof e || !e) return e;
      var n = e[Symbol.toPrimitive];
      if (void 0 !== n) {
        var r = n.call(e, t || "default");
        if ("object" != typeof r) return r;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" == typeof t ? t : t + "";
  }(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Vt(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ht(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Vt(Object(n), !0).forEach(function (t) {
      $t(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Vt(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
var Mt = At.commonBasicLogger;
var qt = function qt(e) {
  return Mt(Ht({
    destination: console.log
  }, e));
};
var zt = {
  promise: Promise.resolve({
    status: 200,
    header: function header() {
      return null;
    },
    body: null
  })
};
function Kt(e, t, n, r, o) {
  if (o && !function () {
    var e = window.navigator && window.navigator.userAgent;
    if (e) {
      var t = e.match(/Chrom(e|ium)\/([0-9]+)\./);
      if (t) return parseInt(t[2], 10) < 73;
    }
    return !0;
  }()) return zt;
  var i = new window.XMLHttpRequest();
  for (var a in i.open(e, t, !o), n || {}) Object.prototype.hasOwnProperty.call(n, a) && i.setRequestHeader(a, n[a]);
  if (o) {
    try {
      i.send(r);
    } catch (e) {}
    return zt;
  }
  var s,
    c = new Promise(function (e, t) {
      i.addEventListener("load", function () {
        s || e({
          status: i.status,
          header: function header(e) {
            return i.getResponseHeader(e);
          },
          body: i.responseText
        });
      }), i.addEventListener("error", function () {
        s || t(new Error());
      }), i.send(r);
    });
  return {
    promise: c,
    cancel: function cancel() {
      s = !0, i.abort();
    }
  };
}
var _t = function _t(e) {
  if ("string" != typeof e) throw new TypeError("Expected a string");
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
};
function Jt(e, t, n, r) {
  var o,
    i,
    a = (("substring" === e.kind || "regex" === e.kind) && r.includes("/") ? t : t.replace(r, "")).replace(n, "");
  switch (e.kind) {
    case "exact":
      i = t, o = new RegExp("^" + _t(e.url) + "/?$");
      break;
    case "canonical":
      i = a, o = new RegExp("^" + _t(e.url) + "/?$");
      break;
    case "substring":
      i = a, o = new RegExp(".*" + _t(e.substring) + ".*$");
      break;
    case "regex":
      i = a, o = new RegExp(e.pattern);
      break;
    default:
      return !1;
  }
  return o.test(i);
}
function Bt(e, t) {
  for (var n = {}, r = null, o = [], i = 0; i < e.length; i++) for (var a = e[i], s = a.urls || [], c = 0; c < s.length; c++) if (Jt(s[c], window.location.href, window.location.search, window.location.hash)) {
    "pageview" === a.kind ? t("pageview", a) : (o.push(a), t("click_pageview", a));
    break;
  }
  return o.length > 0 && (r = function r(e) {
    for (var n = function (e, t) {
        for (var n = [], r = 0; r < t.length; r++) for (var o = e.target, i = t[r], a = i.selector, s = document.querySelectorAll(a); o && s.length > 0;) {
          for (var c = 0; c < s.length; c++) o === s[c] && n.push(i);
          o = o.parentNode;
        }
        return n;
      }(e, o), r = 0; r < n.length; r++) t("click", n[r]);
  }, document.addEventListener("click", r)), n.dispose = function () {
    document.removeEventListener("click", r);
  }, n;
}
function Wt(e, t) {
  var n, r;
  function o() {
    r && r.dispose(), n && n.length && (r = Bt(n, i));
  }
  function i(t, n) {
    var r = e.ident.getContext(),
      o = {
        kind: t,
        key: n.key,
        data: null,
        url: window.location.href,
        creationDate: new Date().getTime(),
        context: r
      };
    return "click" === t && (o.selector = n.selector), e.enqueueEvent(o);
  }
  return e.requestor.fetchJSON("/sdk/goals/" + e.getEnvironmentId()).then(function (e) {
    e && e.length > 0 && (r = Bt(n = e, i), function (e, t) {
      var n,
        r = window.location.href;
      function o() {
        (n = window.location.href) !== r && (r = n, t());
      }
      !function e(t, n) {
        t(), setTimeout(function () {
          e(t, n);
        }, n);
      }(o, e), window.history && window.history.pushState ? window.addEventListener("popstate", o) : window.addEventListener("hashchange", o);
    }(300, o)), t();
  })["catch"](function (n) {
    e.emitter.maybeReportError(new Rt.LDUnexpectedResponseError((n && n.message, n.message))), t();
  }), {};
}
var Gt = "goalsReady",
  Xt = {
    fetchGoals: {
      "default": !0
    },
    hash: {
      type: "string"
    },
    eventProcessor: {
      type: "object"
    },
    eventUrlTransformer: {
      type: "function"
    },
    disableSyncEventPost: {
      "default": !1
    }
  };
function Qt(e, t) {
  var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
    r = function (e) {
      var t,
        n = {
          userAgentHeaderName: "X-LaunchDarkly-User-Agent",
          synchronousFlush: !1
        };
      if (window.XMLHttpRequest) {
        var r = e && e.disableSyncEventPost;
        n.httpRequest = function (e, t, o, i) {
          var a = n.synchronousFlush & !r;
          return n.synchronousFlush = !1, Kt(e, t, o, i, a);
        };
      }
      n.httpAllowsPost = function () {
        return void 0 === t && (t = !!window.XMLHttpRequest && "withCredentials" in new window.XMLHttpRequest()), t;
      }, n.httpFallbackPing = function (e) {
        new window.Image().src = e;
      };
      var o,
        i = e && e.eventUrlTransformer;
      n.getCurrentUrl = function () {
        return i ? i(window.location.href) : window.location.href;
      }, n.isDoNotTrack = function () {
        var e;
        return 1 === (e = window.navigator && void 0 !== window.navigator.doNotTrack ? window.navigator.doNotTrack : window.navigator && void 0 !== window.navigator.msDoNotTrack ? window.navigator.msDoNotTrack : window.doNotTrack) || !0 === e || "1" === e || "yes" === e;
      };
      try {
        window.localStorage && (n.localStorage = {
          get: function get(e) {
            return new Promise(function (t) {
              t(window.localStorage.getItem(e));
            });
          },
          set: function set(e, t) {
            return new Promise(function (n) {
              window.localStorage.setItem(e, t), n();
            });
          },
          clear: function clear(e) {
            return new Promise(function (t) {
              window.localStorage.removeItem(e), t();
            });
          }
        });
      } catch (e) {
        n.localStorage = null;
      }
      if (e && e.useReport && "function" == typeof window.EventSourcePolyfill && window.EventSourcePolyfill.supportedOptions && window.EventSourcePolyfill.supportedOptions.method ? (n.eventSourceAllowsReport = !0, o = window.EventSourcePolyfill) : (n.eventSourceAllowsReport = !1, o = window.EventSource), window.EventSource) {
        var a = 3e5;
        n.eventSourceFactory = function (e, t) {
          var n = Ht(Ht({}, {
            heartbeatTimeout: a,
            silentTimeout: a,
            skipDefaultHeaders: !0
          }), t);
          return new o(e, n);
        }, n.eventSourceIsActive = function (e) {
          return e.readyState === window.EventSource.OPEN || e.readyState === window.EventSource.CONNECTING;
        };
      }
      return n.userAgent = "JSClient", n.version = "3.9.0", n.diagnosticSdkData = {
        name: "js-client-sdk",
        version: "3.9.0"
      }, n.diagnosticPlatformData = {
        name: "JS"
      }, n.diagnosticUseCombinedEvent = !0, n;
    }(n),
    o = jt(e, t, n, r, Xt),
    i = o.client,
    a = o.options,
    s = o.emitter,
    c = new Promise(function (e) {
      var t = s.on(Gt, function () {
        s.off(Gt, t), e();
      });
    });
  i.waitUntilGoalsReady = function () {
    return c;
  }, a.fetchGoals ? Wt(o, function () {
    return s.emit(Gt);
  }) : s.emit(Gt), "complete" !== document.readyState ? window.addEventListener("load", o.start) : o.start();
  var u = function u() {
    r.synchronousFlush = !0, i.flush()["catch"](function () {}), r.synchronousFlush = !1;
  };
  return document.addEventListener("visibilitychange", function () {
    "hidden" === document.visibilityState && u();
  }), window.addEventListener("pagehide", u), i;
}
var Yt = qt,
  Zt = void 0,
  en = "3.9.0";
var tn = {
  initialize: function initialize(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
    return console && console.warn && console.warn(Nt.deprecated("default export", "named LDClient export")), Qt(e, t, n);
  },
  version: en
};
export { Yt as basicLogger, Zt as createConsoleLogger, tn as default, Qt as initialize, en as version };